import { Mail, Phone, MapPin, Clock, Facebook, Instagram, Navigation } from 'lucide-react'
import PageHero from '../components/PageHero'

const contactInfo = [
  {
    icon: Mail,
    title: 'Email',
    info: 'alejandroflorero4@gmail.com',
    description: 'Envíanos un email y te responderemos en 24 horas',
  },
  {
    icon: Phone,
    title: 'Teléfono',
    info: '+52 55 2378 5783',
    description: 'Llámanos los martes y jueves, de 9:30 a 13:00',
  },
  {
    icon: MapPin,
    title: 'Dirección',
    info: 'Centro Deportivo Xochimilco',
    description: 'Francisco Goitia s/n',
  },
]

const socialMedia = [
  {
    icon: Facebook,
    title: 'Facebook',
    info: 'Asociación Nacional de Golf Adaptado A.C.',
    href: 'https://www.facebook.com/AsociacionNacionalDeGolfAdaptadoAc',
  },
  {
    icon: Instagram,
    title: 'Instagram',
    info: '@asociaciongolfadaptadomexico',
    href: 'https://www.instagram.com/asociaciongolfadaptadomexico',
  },
]

const Contact = () => {
  return (
    <div className="min-h-screen bg-ivory">
      <PageHero
        eyebrow="Martes y jueves · 9:30–13:00"
        title="Contáctanos"
        description="¿Quieres jugar, colaborar o tienes una pregunta? Escríbenos. El green está abierto."
      />

      <section className="section-pad mx-auto max-w-7xl">
        <div className="grid gap-5 md:grid-cols-3">
          {contactInfo.map((item) => {
            const Icon = item.icon
            return (
              <article key={item.title} className="rounded-3xl bg-white p-7 ring-1 ring-leaf/10">
                <Icon className="h-6 w-6 text-leaf" aria-hidden="true" />
                <h2 className="mt-5 font-serif text-2xl">{item.title}</h2>
                <p className="mt-2 font-medium text-leaf">{item.info}</p>
                <p className="mt-2 text-sm leading-relaxed text-mist">{item.description}</p>
              </article>
            )
          })}
        </div>
        <div className="mt-5 grid gap-5 md:grid-cols-2">
          {socialMedia.map((item) => {
            const Icon = item.icon
            return (
              <a
                key={item.title}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-5 rounded-3xl bg-fairway p-7 text-cream"
              >
                <Icon className="h-8 w-8 text-sun" aria-hidden="true" />
                <span>
                  <span className="block font-serif text-2xl">{item.title}</span>
                  <span className="mt-1 block text-sm text-cream/70">{item.info}</span>
                </span>
              </a>
            )
          })}
        </div>
      </section>

      <section className="bg-cream py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-12 max-w-2xl">
            <p className="eyebrow">Xochimilco · CDMX</p>
            <h2 className="display mt-4 text-4xl md:text-5xl">Cómo llegar</h2>
            <p className="mt-4 text-lg text-mist">
              Centro Deportivo Xochimilco, a unos pasos de la estación Francisco Goitia del Tren Ligero.
            </p>
          </div>

          <div className="grid items-stretch gap-6 lg:grid-cols-2">
            <div className="min-h-[420px] overflow-hidden rounded-3xl bg-white ring-1 ring-leaf/10 lg:min-h-full">
              <iframe
                src="https://www.google.com/maps?q=Centro+Deportivo+Xochimilco,+Francisco+Goitia,+Xochimilco,+CDMX&hl=es&z=16&output=embed"
                className="h-full min-h-[420px] w-full border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa del Centro Deportivo Xochimilco"
              />
            </div>

            <div className="flex flex-col rounded-3xl bg-white p-8 ring-1 ring-leaf/10 md:p-10">
              <div className="flex items-center gap-3">
                <MapPin className="h-6 w-6 text-leaf" aria-hidden="true" />
                <h3 className="font-serif text-2xl text-ink">Nuestra ubicación</h3>
              </div>

              <dl className="mt-8 space-y-6 text-mist">
                <div>
                  <dt className="text-sm font-semibold uppercase tracking-wide text-leaf">Dirección</dt>
                  <dd className="mt-2 leading-relaxed text-ink">
                    Centro Deportivo Xochimilco<br />
                    Francisco Goitia s/n, barrio Xaltocan<br />
                    Xochimilco, 16095 Ciudad de México
                  </dd>
                </div>
                <div>
                  <dt className="text-sm font-semibold uppercase tracking-wide text-leaf">Cómo llegar</dt>
                  <dd className="mt-2 leading-relaxed">
                    Tren Ligero, estación Francisco Goitia (a unos pasos) o estación terminal Xochimilco.
                    Desde el Metro, Línea 2 hasta Tasqueña y ahí el Tren Ligero.
                  </dd>
                </div>
              </dl>

              <a
                href="https://www.google.com/maps/search/?api=1&query=Centro+Deportivo+Xochimilco+Francisco+Goitia+Xochimilco"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary mt-10 self-start"
              >
                <Navigation className="h-4 w-4" />
                Abrir en Google Maps
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 pb-20 sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 rounded-[2rem] bg-leaf px-8 py-12 text-cream md:flex-row md:items-center md:px-14">
          <div className="flex items-start gap-4">
            <Clock className="mt-1 h-6 w-6 shrink-0 text-sun" aria-hidden="true" />
            <div>
              <h2 className="font-serif text-3xl">Martes y jueves, 9:30 a 13:00</h2>
              <p className="mt-2 max-w-xl text-cream/80">
                Fuera de ese horario, el correo sigue abierto. Respondemos en cuanto podemos.
              </p>
            </div>
          </div>
          <a href="mailto:alejandroflorero4@gmail.com" className="btn-brass shrink-0">
            Escribir un correo
          </a>
        </div>
      </section>
    </div>
  )
}

export default Contact 